import React from 'react';
import styled from 'styled-components';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { Callout, DirectionalHint } from 'office-ui-fabric-react';
import { getFilterList, ITableRequest } from 'api/handbooks/table';
import {
  DefaultButton,
  PrimaryButton,
  Stack,
  IStackTokens,
  Link,
  Label,
} from 'office-ui-fabric-react';
import { Checkbox }  from 'office-ui-fabric-react/lib/Checkbox';
import { Separator } from 'office-ui-fabric-react/lib/Separator';
import { Spinner }   from 'office-ui-fabric-react/lib/Spinner';
import {
  makeFilter,
  FilterComparision,
  IAcceptFilterData,
  makeAllFilter,
  convertMinutesToTime,
}                    from 'views/components/SpreadSheet/utils';
import moment        from 'moment';
import { apiTypes }  from 'shared/consts/handbooksApiTypes';

const MAX_RECORDS_FOR_FILTER = 100;

interface IProps {
  config: any;
  field: {
    title: string;
    name: string;
    type: string;
    width?: string;
    connection?: string;
    disableFilter?: boolean;
    values?: any[];
  };
  sort: {
    field: string;
    direction: string;
  };
  connection?: {
    config: any;
    list: any[];
  };
  onSortChange?: (field: string, direction: string) => void;
  onFilterShow?: (field?: string) => void;
  showFilter?: boolean;
  allFilters: { [key: string]: IAcceptFilterData };
  onFilterAccept?: (data: IAcceptFilterData) => void;
  externalFilters?: any;
}

interface IState {
  filter: string;
  filteredList?: any[];
  filterCount: number;
  loadedCount: number;
  loading: boolean;
  moreLoading: boolean;
  selectedValues: any[];
  isAllSelected: boolean;
}

const HeadContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const HeadTitle = styled.div`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
`;

const FilterButton = styled.div`
  justify-self: flex-end;
  position: relative;
  cursor: pointer;
  border: 1px solid #a6a6a6;
  width: 100%;
  min-height: 30px;
  margin: 5px 0 10px 0;
  padding: 0 5px;
`;

const ItemsContainer = styled.div`
  max-height: 300px;
  overflow-y: auto;
`;

const LoaderContainer = styled.div`
  display: flex;
  height: 100px;
  justify-content: center;
  alignt-items: center;
`;

const EmptyFilter = styled.div`
  display: flex;
  height: 100px;
  justify-content: center;
  align-items: center;
`;

const FilterWindow = styled.div`
  z-index: 4;
`;

class Th extends React.Component<IProps, IState> {
  state = {
    filter: '',
    filteredList: undefined,
    filterCount: 0,
    loadedCount: 0,
    loading: false,
    moreLoading: false,
    isAllSelected: true,
    selectedValues: [] as any[],
  };
  pickerRef = React.createRef<HTMLDivElement>();
  last_filter_timeout: number | undefined = undefined;
  prevFilterRequest?: () => void;

  onSortChangeClick = () => {
    const { field, sort } = this.props;
    if (field.name && this.props.onSortChange) {
      if (sort.field === field.name) {
        this.props.onSortChange(
          sort.field,
          sort.direction === 'asc' ? 'desc' : 'asc'
        );
      } else {
        this.props.onSortChange(field.name, 'asc');
      }
    }
  };

  componentWillUnmount() {
    if (this.last_filter_timeout) {
      clearTimeout(this.last_filter_timeout);
    }
  }

  componentWillReceiveProps(newProps: IProps) {
    if (newProps.showFilter && !this.props.showFilter) {
      this.reloadFilteredData();
    }
    const selectedFilter = (newProps.allFilters || {})[this.props.field.name];
    if (
      selectedFilter != (this.props.allFilters || {})[this.props.field.name]
    ) {
      this.setState({
        isAllSelected:
          (selectedFilter && selectedFilter.isAllSelected) || !selectedFilter,
        filter: (selectedFilter && selectedFilter.filter) || '',
        selectedValues: (selectedFilter && selectedFilter.selectedValues) || [],
      });
    }
  }

  onFilterChange = (vl: string) => {
    if (this.state.moreLoading) {
      return;
    }
    if (this.last_filter_timeout) {
      clearTimeout(this.last_filter_timeout);
    }

    this.setState({ filter: vl }, () => {
      setTimeout(() => {
        this.setState({ isAllSelected: true, selectedValues: [] });
        this.reloadFilteredData();
      }, 300);
    });
  };

  getFilter = (
    offset: number = 0,
    limit: number = MAX_RECORDS_FOR_FILTER
  ): ITableRequest => {
    const { config } = this.props;

    //console.log(this.props.connection, this.props.field);
    let filter: string = '';
    if (!this.props.connection) {
      filter = makeAllFilter({
        ...(this.props.allFilters || {}),
        ...{
          [this.props.field.name]: {
            field: this.props.field,
            filter: this.state.filter,
            selectedValues: [],
            isAllSelected: true,
          },
        },
      });
    } else {
      const connection = this.props.connection;
      filter = makeAllFilter(this.props.allFilters || {});
      if (this.state.filter && this.state.filter.length > 0) {
        const txtFilter = this.state.filter.toLowerCase();
        const indexes = (connection.list || [])
          .filter((cn: any) => {
            return (
              (connection.config.format(cn) + '')
                .toLowerCase()
                .indexOf(txtFilter) >= 0
            ); // !!connection.config.fields.find((fld: any) => (cn[fld] || '').toLowerCase().indexOf(txtFilter) >= 0);
          })
          .map((cn: any) => `'${cn[connection.config.index]}'`);
        const indFilter = `"${
          this.props.field.name
        }"::text like any(array[${indexes.join(',')}])`;
        filter =
          filter.length === 0 ? indFilter : `(${filter}) AND (${indFilter})`;
      }
    }
    return {
      schema: config.schema,
      table: config.table,
      fields: [this.props.field.name],
      sort: {
        field: this.props.field.name,
        direction: 'asc',
      },
      offset,
      limit,
      distinct: true,
      filters:
        this.props.externalFilters && this.props.externalFilters != ''
          ? `(${this.props.externalFilters}) ${
              filter || filter != '' ? ` AND (${filter})` : ''
            }`
          : filter,
      //   makeFilter(
      //   this.props.field,
      //   this.state.filter,
      //   FilterComparision.LIKE_FULL
      // ),
      apiType: apiTypes.DEFAULT
    };
  };

  moreFilters = () => {
    this.setState({ moreLoading: true });
    const params = getFilterList(
      this.getFilter(this.state.loadedCount * 1 || 0)
    );
    this.prevFilterRequest = params.cancel;
    params.request.then((data: any) => {
      this.setState({
        filteredList: [
          ...(this.state.filteredList || []),
          ...((data && data.list) || []),
        ],
        filterCount: (data && data.count) || 0,
        loadedCount:
          this.state.loadedCount + ((data && data.list) || []).length,
        moreLoading: false,
      });
    });
  };

  reloadFilteredData = async () => {
    this.setState({ loading: true, loadedCount: 0 });
    const params = getFilterList(this.getFilter());
    this.prevFilterRequest = params.cancel;
    params.request.then((data: any) => {
      this.setState({
        filteredList: (data && data.list) || [],
        filterCount: (data && data.count) || 0,
        loadedCount:
          this.state.loadedCount + ((data && data.list) || []).length,
        loading: false,
      });
    });
  };

  onFilterShowClick = () => {
    this.props.onFilterShow && this.props.onFilterShow(this.props.field.name);
  };

  onFilterClose = () => {
    this.props.onFilterShow && this.props.onFilterShow(undefined);
  };

  onIsAllChecked = (
    ev: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
    vl?: boolean
  ) => {
    this.setState({ selectedValues: [], isAllSelected: vl || false });
  };

  onElementChecked = (element: any, vl?: boolean) => {
    if (this.state.isAllSelected && !vl) {
      const selectedValues = (this.state.filteredList || [])
        .filter((el: any) => el !== element)
        .map((el: any) => el[this.props.field.name]);
      this.setState({ selectedValues, isAllSelected: false });
    } else {
      const selectedValues = !vl
        ? this.state.selectedValues.filter(
            (el: any) => el !== element[this.props.field.name]
          )
        : [...this.state.selectedValues, element[this.props.field.name]];
      if (selectedValues.length === (this.state.filteredList || []).length) {
        this.setState({ selectedValues: [], isAllSelected: true });
      } else
        this.setState({
          selectedValues,
          isAllSelected: false,
        });
    }
  };

  onFiltersAccept = () => {
    this.props.onFilterAccept &&
      this.props.onFilterAccept({
        field: this.props.field,
        filter: this.state.filter,
        selectedValues: this.state.selectedValues,
        isAllSelected: this.state.isAllSelected,
        connectionFilterValues:
          this.props.field.connection && this.state.isAllSelected
            ? (this.state.filteredList || []).map(
                (el: any) => el[this.props.field.name]
              )
            : undefined,
      });
    this.props.onFilterShow && this.props.onFilterShow(undefined);
  };

  isFiltered = (): boolean => {
    return (
      this.state.filter !== '' || (this.state.selectedValues || []).length > 0
    );
  };

  getConnectionName = (
    connection: { config: any; list: any[] },
    index: any
  ): string => {
    const cn = connection.list.find(
      (cl) => cl[connection.config.index] == index
    );
    if (cn) {
      return connection.config.format(cn);
    }
    return index;
  };

  getListName = (list: any[], index: any) => {
    const vl = list.find(
      (elem: { key: any; value: any }) => elem.key === index
    );
    if (vl) {
      return vl.value;
    }
    return index;
  };

  getFormatedField = (value: string) => {
    if (this.props.field.type === 'date') {
      return (value && moment(value).format('DD.MM.YYYY')) || '';
    }
    if (this.props.field.type === 'timeminutes') {
      return value && convertMinutesToTime(parseInt(value));
    }
    if (this.props.field.type === 'boolean') {
      return (value && 'Да') || 'Нет';
    }
    return value + '';
  };

  getFilterList = (): { key: any; value: string; data: any }[] => {
    const { field, connection } = this.props;
    return (this.state.filteredList || []).map((el) => {
      return {
        key: el[field.name],
        value: connection
          ? this.getConnectionName(connection, el[field.name])
          : field.type === 'list'
          ? this.getListName(field.values || [], el[field.name])
          : this.getFormatedField(el[field.name]),
        data: el,
      };
    });
  };

  getSelectedFilters = () => {
    const { field, connection } = this.props;
    return this.isFiltered()
      ? this.state.isAllSelected
        ? `${this.state.filter}...`
        : this.state.selectedValues
            .map((index: any) =>
              connection
                ? this.getConnectionName(connection, index)
                : field.type === 'list'
                ? this.getListName(field.values || [], index)
                : this.getFormatedField(index)
            )
            .join('; ')
      : '';
  };

  render() {
    const { field, sort } = this.props;
    //const { sort } = this.state;
    return (
      <>
        <HeadContainer onClick={this.onSortChangeClick}>
          <HeadTitle>{field.title}:</HeadTitle>
          {(field.name && sort.field === field.name && (
            <Icon
              iconName={sort.direction === 'desc' ? 'SortUp' : 'SortDown'}
            />
          )) || <Icon iconName={'Sort'} style={{ color: '#ddd' }} />}
        </HeadContainer>
        {!this.props.showFilter && (
          <FilterButton ref={this.pickerRef} onClick={this.onFilterShowClick}>
            {this.getSelectedFilters()}
          </FilterButton>
        )}
        {this.props.showFilter && (
          <FilterWindow>
            <SearchBox
              placeholder="Фильтр"
              iconProps={{ iconName: 'Filter' }}
              onChange={this.onFilterChange}
            />
            {this.state.loading && (
              <LoaderContainer>
                <Spinner label="Загрузка..." />
              </LoaderContainer>
            )}
            {!this.state.loading &&
              ((this.state.filteredList || []).length > 0 ? (
                <Stack
                  horizontal={false}
                  styles={{
                    root: { padding: '10px', minHeight: '100px' },
                  }}
                >
                  <Checkbox
                    label="Все элементы"
                    checked={this.state.isAllSelected}
                    onChange={this.onIsAllChecked}
                  />
                  <Separator />
                  <ItemsContainer>
                    <Stack horizontal={false} tokens={{ childrenGap: 10 }}>
                      {this.getFilterList().map((el) => (
                        <Checkbox
                          key={el.key}
                          label={el.value}
                          checked={
                            this.state.isAllSelected ||
                            this.state.selectedValues.indexOf(el.key) >= 0
                          }
                          onChange={(ev, vl) =>
                            this.onElementChecked(el.data, vl)
                          }
                        />
                      ))}
                      {this.state.loadedCount < this.state.filterCount &&
                        (this.state.moreLoading ? (
                          <Label
                            styles={{
                              root: {
                                padding: '0',
                              },
                            }}
                          >
                            Загрузка...
                          </Label>
                        ) : (
                          <Link onClick={this.moreFilters}>Показать еще</Link>
                        ))}
                    </Stack>
                  </ItemsContainer>
                </Stack>
              ) : (
                <EmptyFilter>Ничего не найдено.</EmptyFilter>
              ))}

            {/*  */}
            <Stack
              horizontal
              horizontalAlign={'end'}
              tokens={{ childrenGap: 10 }}
            >
              <PrimaryButton
                text="Применить"
                disabled={
                  (!this.state.isAllSelected &&
                    this.state.selectedValues.length === 0) ||
                  (this.state.filteredList || []).length === 0
                }
                onClick={this.onFiltersAccept}
              />
              <DefaultButton text="Отмена" onClick={this.onFilterClose} />
            </Stack>
          </FilterWindow>
        )}
      </>
    );
  }
}

export default Th;
